// pp-fill.js — fills your data-pp placeholders from metafields
(function () {
  if (!window.PP) return;
  // console.log('PP script loaded');

  // ---------- helpers ----------
  function formatMoney2(cents) {
    // With cents (for Monthly Payment)
    try { if (typeof Shopify !== 'undefined' && Shopify.formatMoney) return Shopify.formatMoney(cents, PP.moneyFormat); }
    catch(_) {}
    const code = PP.currencyCode || 'USD';
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: code, minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function formatMoney0(cents) {
    // No cents (clean look for all other rows)
    const code = PP.currencyCode || 'USD';
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: code, minimumFractionDigits: 0, maximumFractionDigits: 0 });
  }
  function monthsBetween(from, to) {
    let m = (to.getFullYear() - from.getFullYear()) * 12 + (to.getMonth() - from.getMonth());
    if (to.getDate() > from.getDate()) m += 1;
    return Math.max(1, m);
  }
  function humanOffset(days) {
    const n = Number(days) || 0;
    if (n % 7 === 0 && n !== 0) { const w = n / 7; return w + ' week' + (w > 1 ? 's' : ''); }
    return n + ' day' + (n === 1 ? '' : 's');
  }
  function currentVariantId() {
    const select = document.querySelector('select[name="id"]');
    if (select) return select.value;
    const selected = document.querySelector('[data-selected-variant-id]');
    if (selected) return selected.getAttribute('data-selected-variant-id');
    const form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      const hidden = form.querySelector('input[name="id"][type="hidden"]');
      if (hidden) return hidden.value;
    }
    return null;
  }

  function planFeeFromPlanVariant() {
  try {
    if (!window.PP || !PP.variantData) return Number(PP.planFeeCents || 0);
    // Prefer the variant flagged as plan, else any title containing "plan"
    for (const id in PP.variantData) {
      const v = PP.variantData[id];
      if (!v) continue;
      const isPlan = !!(v.isPlan || /plan/i.test(String(v.title || '')));
      if (isPlan) {
        const cents = Number(v.planFeeCents || 0);
        if (!Number.isNaN(cents) && cents > 0) return cents;
      }
    }
    // Fallback to the current variant’s fee if no explicit plan variant found
    const vid = (function () {
      const form = document.querySelector('form[action*="/cart/add"]');
      if (form) {
        const hidden = form.querySelector('input[name="id"][type="hidden"]');
        if (hidden && hidden.value) return hidden.value;
        const sel = form.querySelector('select[name="id"]');
        if (sel && sel.value) return sel.value;
      }
      const select = document.querySelector('select[name="id"]');
      if (select) return select.value;
      const selected = document.querySelector('[data-selected-variant-id]');
      if (selected) return selected.getAttribute('data-selected-variant-id');
      return null;
    })();
    if (vid && PP.variantData[vid]) return Number(PP.variantData[vid].planFeeCents || 0);
  } catch (_) {}
  return 0;
}

  // ---------- core ----------
 function getNumbers() {
  const vid = currentVariantId();
  const base = {
    packageCents: Number(PP.packageCents || 0),
    serviceFeeCents: Number(PP.serviceFeeCents || 0),
    // Plan fee comes from the Payment Plan variant (not the current one)
    planFeeCents: planFeeFromPlanVariant()
  };
  if (vid && PP.variantData && PP.variantData[vid]) {
    const v = PP.variantData[vid];
    // Allow variant-level overrides for package/service if you use them
    if (v.packageCents != null)    base.packageCents    = Number(v.packageCents);
    if (v.serviceFeeCents != null) base.serviceFeeCents = Number(v.serviceFeeCents);
    // DO NOT override planFeeCents here; we want the plan variant’s fee
  }
  return base;
}


  function compute() {
  const { packageCents, serviceFeeCents, planFeeCents } = getNumbers();

  // Dates
  const now = new Date();
  const firstOffset   = Number(PP.firstPaymentOffsetDays || 14);
  const payFullOffset = Number(PP.payFullBalanceOffsetDays || 7);

  const firstPaymentDateObj = new Date();
  firstPaymentDateObj.setDate(firstPaymentDateObj.getDate() + firstOffset);

  // Months/per-month: only if we have a valid future delivery date
  let months = null;
  let perMonthCents = null;
  if (PP.deliveryDateISO) {
    const delivery = new Date(PP.deliveryDateISO + 'T00:00:00');
    if (!isNaN(delivery) && delivery > now) {
      // Count months from the first payment date to delivery
      months = monthsBetween(firstPaymentDateObj, delivery);
      if (months && months > 0) perMonthCents = Math.ceil(packageCents / months);
    }
  }

  return {
    months,
    packageCents,
    serviceFeeCents,
    planFeeCents,
    feesTodayPlanCents: serviceFeeCents + planFeeCents,
    payFullTotalCents: packageCents + serviceFeeCents,
    planTotalCents: packageCents + serviceFeeCents + planFeeCents,
    perMonthCents, // may be null if no delivery date
    payFullBalanceIn: humanOffset(PP.payFullBalanceOffsetDays),
    firstPaymentIn:  humanOffset(PP.firstPaymentOffsetDays),
    firstPaymentDate: firstPaymentDateObj.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' })
  };
}


  function setText(scope, key, text) {
    scope.querySelectorAll('[data-pp="' + key + '"]').forEach(el => { el.textContent = text; });
  }

  function render() {
    const plan = compute();
    const scopes = document.querySelectorAll('[data-pp-scope]');
    const list = scopes.length ? scopes : [document];

    list.forEach(scope => {
      if (!plan) { scope.style.display = 'none'; return; }
      scope.style.removeProperty('display');

      // No cents for these:
      setText(scope, 'package',        formatMoney0(plan.packageCents));
      setText(scope, 'serviceFee',     formatMoney0(plan.serviceFeeCents));
      setText(scope, 'planFee',        formatMoney0(plan.planFeeCents));
      setText(scope, 'payFullTotal',   formatMoney0(plan.payFullTotalCents));
      setText(scope, 'planTotal',      formatMoney0(plan.planTotalCents));
      setText(scope, 'feesTodayPlan',  formatMoney0(plan.feesTodayPlanCents));

      // Keep cents for monthly amount:
      setText(scope, 'perMonth',       formatMoney2(plan.perMonthCents));

      // Not money:
      setText(scope, 'months', String(plan.months));
      setText(scope, 'payFullBalanceIn', plan.payFullBalanceIn);
      setText(scope, 'firstPaymentIn',   plan.firstPaymentDate);
    });
  }

  render();
  document.addEventListener('variant:change', render);
  const sel = document.querySelector('select[name="id"]');
  if (sel) sel.addEventListener('change', render);
})();
